import React from 'react';
import { defaultTheme } from './../../styles/theme/default';

export function AddPhoto () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke={defaultTheme.colors.dimGray}
        d="M.5 6.5a2 2 0 012-2h11a2 2 0 012 2v7a2 2 0 01-2 2h-11a2 2 0 01-2-2v-7zM13 4.5l-1.724-3.447A1 1 0 0010.382.5H5.618a1 1 0 00-.894.553L3 4.5"
      />
      <path
        stroke={defaultTheme.colors.dimGray}
        d="M11.5 10a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"
      />
      <path
        stroke={defaultTheme.colors.dimGray}
        strokeLinecap="round"
        d="M6 10a2 2 0 012-2M6.5 2.5h3"
      />
    </svg>
  );
}
